<template>
  <div class="administradoras-selector-wrapper">
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        :offset-y="!isMobile"
        :offset-x="false"
        :max-width="isMobile ? '95vw' : '420'"
        :min-width="isMobile ? '95vw' : '400'"
        :content-class="isMobile ? 'mobile-menu' : ''"
        :nudge-bottom="isMobile ? 0 : 10"
        :top="isMobile"
        :bottom="!isMobile"
        :attach="isMobile ? 'body' : false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            :value="displayAdministradora"
            :placeholder="placeholder"
            prepend-inner-icon="mdi-credit-card-multiple-outline"
            readonly
            dense
            outlined
            hide-details
            :disabled="disabled"
            :loading="loading"
            class="administradoras-field"
            v-bind="attrs"
            v-on="on"
            :label="label"
        >
          <template v-slot:append v-if="value && showCheckIcon">
            <v-icon :color="checkIconColor">mdi-check-circle</v-icon>
          </template>
        </v-text-field>
      </template>

      <v-card class="administradoras-menu-card" :class="{ 'mobile-card': isMobile }">
        <!-- Header Mobile -->
        <v-card-title v-if="isMobile" class="mobile-header">
          <div class="mobile-header-content">
            <v-icon color="white" small>mdi-credit-card-multiple-outline</v-icon>
            <span class="mobile-header-title">Selecionar Administradora</span>
          </div>
          <v-btn icon small color="white" @click="fecharModal">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Conteúdo -->
        <div class="administradoras-content" :class="{ 'mobile-content': isMobile }">

          <!-- Busca -->
          <v-card-text class="py-2 px-3 busca-section">
            <v-text-field
                v-model="busca"
                placeholder="Buscar administradora..."
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                class="busca-field"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Lista -->
          <div class="administradoras-list-wrapper">
            <v-virtual-scroll
                :items="administradorasFiltradas"
                :height="isMobile ? listHeightMobile : 280"
                :item-height="44"
            >
              <template v-slot:default="{ item }">
                <div class="adm-item-wrapper">
                  <v-list-item
                      dense
                      @click="selecionar(item)"
                      :class="{ 'adm-selecionada': value === item.idadministradora }"
                      class="adm-item"
                  >
                    <v-list-item-action class="mr-2 my-0">
                      <v-icon
                          small
                          :color="value === item.idadministradora ? '#023449' : '#cbd5e1'"
                      >
                        {{ value === item.idadministradora ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content class="py-1">
                      <v-list-item-title class="adm-nome">
                        {{ item.administradora }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="item.descricao" class="adm-info">
                        {{ item.descricao }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action v-if="value === item.idadministradora" class="my-0 ml-1">
                      <v-icon small color="#023449">mdi-check</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="item-divider"></v-divider>
                </div>
              </template>
            </v-virtual-scroll>

            <!-- Estado vazio -->
            <div v-if="administradorasFiltradas.length === 0" class="empty-state">
              <v-icon color="grey lighten-2" size="32">mdi-credit-card-off-outline</v-icon>
              <span class="empty-text">Nenhuma administradora encontrada</span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <v-divider></v-divider>
        <v-card-actions class="py-2 px-3 menu-footer">
          <v-chip
              v-if="admSelecionada"
              x-small
              outlined
              color="#023449"
              class="count-chip"
          >
            <v-icon x-small left>mdi-check-circle</v-icon>
            {{ admSelecionada.administradora }}
          </v-chip>
          <span v-else class="text-empty">Nenhuma selecionada</span>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'SeletorAdministradoras',

  props: {
    value: {
      type: Number,
      default: null
    },
    administradoras: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Selecione a administradora'
    },
    showCheckIcon: {
      type: Boolean,
      default: true
    },
    checkIconColor: {
      type: String,
      default: 'success'
    },
  },

  data() {
    return {
      menu: false,
      busca: '',
      selecaoInterna: null,
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    isMobile() {
      return this.windowWidth < 960;
    },

    listHeightMobile() {
      return Math.max(200, window.innerHeight * 0.85 - 200);
    },

    administradorasFiltradas() {
      if (!this.busca) return this.administradoras;
      const termo = this.busca.toLowerCase();
      return this.administradoras.filter(a =>
          a.administradora.toLowerCase().includes(termo) ||
          String(a.idadministradora).includes(termo)
      );
    },

    admSelecionada() {
      if (!this.selecaoInterna) return null;
      return this.administradoras.find(a => a.idadministradora === this.selecaoInterna) || null;
    },

    displayAdministradora() {
      if (!this.value) return '';
      const adm = this.administradoras.find(a => a.idadministradora === this.value);
      return adm ? adm.administradora : '';
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selecaoInterna = val;
      },
    },

    menu(opened) {
      if (opened) {
        this.selecaoInterna = this.value;
        this.busca = '';
        if (this.isMobile) document.body.style.overflow = 'hidden';
      } else {
        if (this.isMobile) document.body.style.overflow = '';
      }
    },
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    selecionar(item) {
      this.selecaoInterna = item.idadministradora;
      this.$emit('input', item.idadministradora);
      this.$emit('change', item.idadministradora);
      this.fecharModal();
    },

    fecharModal() {
      this.menu = false;
    },
  },
};
</script>

<style scoped>
.administradoras-selector-wrapper {
  width: 100%;
}

/* ===== INPUT ===== */
.administradoras-field >>> .v-input__control {
  min-height: 44px !important;
}

.administradoras-field >>> fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
  transition: all 0.2s ease;
}

.administradoras-field >>> .v-input__slot {
  background: #f8fafc;
  transition: all 0.2s ease;
  border-radius: 10px;
}

.administradoras-field >>> .v-input__prepend-inner .v-icon,
.administradoras-field >>> .v-input__append .v-icon {
  color: #023449 !important;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.administradoras-field:hover >>> .v-input__prepend-inner .v-icon,
.administradoras-field:hover >>> .v-input__append .v-icon {
  opacity: 1 !important;
}

.administradoras-field >>> .v-input__slot:hover {
  background: #ffffff;
}

.administradoras-field >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}

.administradoras-field >>> .v-input--is-focused fieldset {
  border-color: #023449 !important;
  border-width: 2px;
  box-shadow: 0 0 0 3px rgba(2, 52, 73, 0.1);
}

.administradoras-field >>> .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

/* ===== MENU CARD ===== */
.administradoras-menu-card {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(2, 52, 73, 0.15) !important;
  overflow: hidden;
}

.mobile-card {
  max-width: 95vw !important;
  width: 95vw !important;
  max-height: 85vh !important;
  display: flex;
  flex-direction: column;
}

/* ===== HEADER MOBILE ===== */
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: linear-gradient(135deg, #023449 0%, #035a7a 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.2);
  flex-shrink: 0;
}

.mobile-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-header-title {
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

/* ===== CONTEÚDO ===== */
.administradoras-content {
  display: flex;
  flex-direction: column;
  height: auto;
}

.mobile-content {
  max-height: calc(85vh - 92px);
  min-height: 0;
  flex: 1;
  overflow: hidden;
}

.busca-section {
  flex-shrink: 0;
}

/* ===== BUSCA ===== */
.busca-field >>> .v-input__control {
  min-height: 36px !important;
}

.busca-field >>> fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
}

.busca-field >>> .v-input__slot {
  background: #f8fafc;
  border-radius: 8px;
  min-height: 36px !important;
}

.busca-field >>> .v-text-field__details {
  display: none;
}

.busca-field >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}

.busca-field >>> .v-input--is-focused fieldset {
  border-color: #023449 !important;
}

/* ===== LISTA ===== */
.administradoras-list-wrapper {
  background: #ffffff;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  position: relative;
}

.adm-item-wrapper {
  background: #ffffff;
}

.adm-item {
  transition: background-color 0.15s ease;
  cursor: pointer;
  min-height: 44px !important;
  max-height: 44px !important;
  padding: 4px 12px !important;
  background: #ffffff !important;
}

.adm-item:hover {
  background-color: rgba(2, 52, 73, 0.04) !important;
}

.adm-selecionada {
  background-color: rgba(2, 52, 73, 0.07) !important;
}

.item-divider {
  margin: 0 !important;
  border-color: #e2e8f0 !important;
}

.adm-nome {
  font-size: 0.813rem;
  font-weight: 600;
  color: #023449;
  line-height: 1.2;
}

.adm-info {
  font-size: 0.688rem;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.2;
}

/* ===== EMPTY STATE ===== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  gap: 8px;
}

.empty-text {
  font-size: 0.75rem;
  color: #94a3b8;
  font-style: italic;
}

/* ===== FOOTER ===== */
.menu-footer {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  min-height: 44px !important;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.count-chip {
  font-weight: 600;
  border-width: 1.5px !important;
  height: 20px !important;
  font-size: 0.688rem;
  max-width: 200px;
}

.count-chip >>> .v-chip__content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-empty {
  font-size: 0.688rem;
  color: #94a3b8;
  font-style: italic;
}

/* ===== SCROLLBAR ===== */
.administradoras-list-wrapper::-webkit-scrollbar {
  width: 3px;
}

.administradoras-list-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.administradoras-list-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.administradoras-list-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ===== MENU MOBILE ===== */
.mobile-menu {
  position: fixed !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  max-width: 95vw !important;
  max-height: 85vh !important;
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 599px) {
  .mobile-header {
    padding: 8px 10px;
  }

  .mobile-header-title {
    font-size: 0.813rem;
  }

  .busca-section {
    padding: 8px 10px !important;
  }

  .adm-item {
    min-height: 40px !important;
    max-height: 40px !important;
    padding: 4px 10px !important;
  }

  .adm-nome {
    font-size: 0.75rem;
  }

  .adm-info {
    font-size: 0.625rem;
  }

  .menu-footer {
    padding: 6px 10px !important;
  }

  .action-btn-primary {
    font-size: 0.625rem !important;
    height: 26px !important;
    padding: 0 10px !important;
  }
}

/* ===== LANDSCAPE MOBILE ===== */
@media (max-width: 960px) and (orientation: landscape) {
  .mobile-content {
    max-height: 80vh;
  }
}

/* ===== ACESSIBILIDADE ===== */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>